@if (action == 'index') {
	<div class="container">
		<div class="d-flex justify-content-between align-items-center">
			<h1 class="fs-2 fw-light mt-4">Choose Property</h1>
			<button (click)="goBack()" class="btn btn-primary">Back <fa-icon [icon]="faCircleArrowLeft"></fa-icon></button>
		</div>

		<div class="form-group has-search my-3">
			<fa-icon class="form-control-feedback" [icon]="faSearch"></fa-icon>
			<input type="text" name="searchProperty" [(ngModel)]="searchProperty" class="form-control" placeholder="Search by property name" />
		</div>

		@if (loadingProperties) {
			<div class="my-4">
				<span class="spinner-border spinner-border-sm mr-1"></span>
				<span>Loading properties...</span>
			</div>
		}

		@if (!loadingProperties && properties.length == 0) {
			<div class="alert alert-info">No properties found.</div>
		}

		<ul class="list-group list-group-flush col-md-6">
			@for (property  of properties | filter: searchProperty ; track property ) {
				<li (click)="onSelectedProperty(property)" class="fs-3 text-primary list-group-item list-group-item-action d-flex justify-content-between align-items-center">
					@if (property.property_type == 'house') {
						<fa-icon class="l-icon" [icon]="faHouse"></fa-icon>
					}
					@if (property.property_type == 'strata') {
						<fa-icon class="l-icon" [icon]="faBuilding"></fa-icon>
					}
					@if (property.property_type == 'Townhouse') {
						<fa-icon class="l-icon" [icon]="faHouseChimney"></fa-icon>
					}
					<span class="text-black fw-lighter">{{property.name}} </span>
					<fa-icon [icon]="faCircleArrowRight"></fa-icon>
				</li>
			}
		</ul>
	</div>
}

@if (action != 'index' && !property?.id) {
	<div class="container">
		<h1 class="fs-2 fw-light mt-4">Manage Breaches</h1>
		<div class="alert alert-warning mt-4">
			No property selected. Choose a property first to manage breaches.
		</div>
		<button (click)="goBack()" type="button" class="btn btn-primary">
			<fa-icon [icon]="faCircleArrowLeft"></fa-icon> Back
		</button>
	</div>
}

@if (action != 'index' && property?.id && properties.length > 1) {
	<div class="container mt-3">
		<button (click)="onChangeProperty()" type="button" class="btn btn-sm btn-outline-secondary">Change property</button>
	</div>
}

@if (property?.id && action == 'create') {
	<div class="container">
		<h1 class="fs-2 fw-light mt-4">Create Breach</h1>
		<form [formGroup]="addBreachForm">
			<div class="form-group my-3">
				<label class="form-label" for="title">Title</label>
				<input class="form-control" id="title" type="text" formControlName="title" [ngClass]="{ 'is-invalid': submitBreachData && fba.title.errors }" />
			</div>

			<div class="form-group my-3">
				<label class="form-label" for="description">Description</label>
				<textarea class="form-control" id="description" rows="4" formControlName="description" [ngClass]="{ 'is-invalid': submitBreachData && fba.description.errors }"></textarea>
			</div>

			<div class="row">
				<div class="col-md-4 form-group my-2">
					<label class="form-label" for="firstname">First Name</label>
					<input class="form-control" id="firstname" type="text" formControlName="firstname" [ngClass]="{ 'is-invalid': submitBreachData && fba.firstname.errors }" />
				</div>
				<div class="col-md-4 form-group my-2">
					<label class="form-label" for="middlename">Middle Name</label>
					<input class="form-control" id="middlename" type="text" formControlName="middlename" />
				</div>
				<div class="col-md-4 form-group my-2">
					<label class="form-label" for="lastname">Last Name</label>
					<input class="form-control" id="lastname" type="text" formControlName="lastname" [ngClass]="{ 'is-invalid': submitBreachData && fba.lastname.errors }" />
				</div>
			</div>

			<div class="row">
				<div class="col-md-4 form-group my-2">
					<label class="form-label" for="datereported">Date Reported</label>
					<input class="form-control" id="datereported" type="date" formControlName="datereported" [ngClass]="{ 'is-invalid': submitBreachData && fba.datereported.errors }" />
				</div>
				<div class="col-md-4 form-group my-2">
					<label class="form-label" for="unit_number">Unit Number</label>
					<input class="form-control" id="unit_number" type="number" formControlName="unit_number" [ngClass]="{ 'is-invalid': submitBreachData && fba.unit_number.errors }" />
				</div>
				<div class="col-md-4 form-group my-2">
					<label class="form-label" for="bylawid">Bylaw ID</label>
					<input class="form-control" id="bylawid" type="number" formControlName="bylawid" />
				</div>
			</div>

			<div class="row">
				<div class="col-md-6 form-group my-2">
					<label class="form-label" for="createdBy">Reported By</label>
					<input class="form-control" id="createdBy" type="text" formControlName="createdBy" [ngClass]="{ 'is-invalid': submitBreachData && fba.createdBy.errors }" />
				</div>
				<div class="col-md-6 form-group my-2">
					<label class="form-label" for="status">Status</label>
					<select class="form-select" id="status" formControlName="status" [ngClass]="{ 'is-invalid': submitBreachData && fba.status.errors }">
						<option value="open">Open</option>
						<option value="in-progress">In Progress</option>
						<option value="closed">Closed</option>
					</select>
				</div>
			</div>

			<div class="form-group my-3">
				<label class="form-label" for="propertyName">Property</label>
				<input class="form-control" id="propertyName" type="text" formControlName="propertyName" readonly />
				<input type="hidden" formControlName="propertyId" />
			</div>
		</form>
	</div>
}

@if (property?.id && action == 'edit') {
	<div class="container">
		<h1 class="fs-2 fw-light mt-4">Edit Breach</h1>
		<form [formGroup]="editBreachForm">
			<input type="hidden" formControlName="id" />

			<div class="form-group my-3">
				<label class="form-label" for="editTitle">Title</label>
				<input class="form-control" id="editTitle" type="text" formControlName="title" [ngClass]="{ 'is-invalid': submitBreachData && fbe.title.errors }" />
			</div>

			<div class="form-group my-3">
				<label class="form-label" for="editDescription">Description</label>
				<textarea class="form-control" id="editDescription" rows="4" formControlName="description" [ngClass]="{ 'is-invalid': submitBreachData && fbe.description.errors }"></textarea>
			</div>

			<div class="row">
				<div class="col-md-4 form-group my-2">
					<label class="form-label" for="editFirstname">First Name</label>
					<input class="form-control" id="editFirstname" type="text" formControlName="firstname" [ngClass]="{ 'is-invalid': submitBreachData && fbe.firstname.errors }" />
				</div>
				<div class="col-md-4 form-group my-2">
					<label class="form-label" for="editMiddlename">Middle Name</label>
					<input class="form-control" id="editMiddlename" type="text" formControlName="middlename" />
				</div>
				<div class="col-md-4 form-group my-2">
					<label class="form-label" for="editLastname">Last Name</label>
					<input class="form-control" id="editLastname" type="text" formControlName="lastname" [ngClass]="{ 'is-invalid': submitBreachData && fbe.lastname.errors }" />
				</div>
			</div>

			<div class="row">
				<div class="col-md-4 form-group my-2">
					<label class="form-label" for="editDateReported">Date Reported</label>
					<input class="form-control" id="editDateReported" type="date" formControlName="datereported" [ngClass]="{ 'is-invalid': submitBreachData && fbe.datereported.errors }" />
				</div>
				<div class="col-md-4 form-group my-2">
					<label class="form-label" for="editUnitNumber">Unit Number</label>
					<input class="form-control" id="editUnitNumber" type="number" formControlName="unit_number" [ngClass]="{ 'is-invalid': submitBreachData && fbe.unit_number.errors }" />
				</div>
				<div class="col-md-4 form-group my-2">
					<label class="form-label" for="editBylawId">Bylaw ID</label>
					<input class="form-control" id="editBylawId" type="number" formControlName="bylawid" />
				</div>
			</div>

			<div class="row">
				<div class="col-md-6 form-group my-2">
					<label class="form-label" for="editCreatedBy">Reported By</label>
					<input class="form-control" id="editCreatedBy" type="text" formControlName="createdBy" [ngClass]="{ 'is-invalid': submitBreachData && fbe.createdBy.errors }" />
				</div>
				<div class="col-md-6 form-group my-2">
					<label class="form-label" for="editStatus">Status</label>
					<select class="form-select" id="editStatus" formControlName="status" [ngClass]="{ 'is-invalid': submitBreachData && fbe.status.errors }">
						<option value="open">Open</option>
						<option value="in-progress">In Progress</option>
						<option value="closed">Closed</option>
					</select>
				</div>
			</div>

			<div class="form-group my-3">
				<label class="form-label" for="editPropertyName">Property</label>
				<input class="form-control" id="editPropertyName" type="text" formControlName="propertyName" readonly />
				<input type="hidden" formControlName="propertyId" />
			</div>
		</form>
	</div>
}

@if (property?.id && action == 'view') {
	<div class="container">
		<div class="d-flex justify-content-between align-items-center">
			<h1 class="fs-2 fw-light mt-4">View Breach</h1>
			<button (click)="onEditBreach()" type="button" class="mt-4 btn btn-primary">
				Edit <fa-icon [icon]="faPenToSquare"></fa-icon>
			</button>
		</div>

		<form [formGroup]="viewBreachForm">
			<div class="form-group my-3">
				<label class="form-label">Title</label>
				<input class="form-control" type="text" formControlName="title" readonly />
			</div>

			<div class="form-group my-3">
				<label class="form-label">Description</label>
				<textarea class="form-control" rows="4" formControlName="description" readonly></textarea>
			</div>

			<div class="row">
				<div class="col-md-4 form-group my-2">
					<label class="form-label">First Name</label>
					<input class="form-control" type="text" formControlName="firstname" readonly />
				</div>
				<div class="col-md-4 form-group my-2">
					<label class="form-label">Middle Name</label>
					<input class="form-control" type="text" formControlName="middlename" readonly />
				</div>
				<div class="col-md-4 form-group my-2">
					<label class="form-label">Last Name</label>
					<input class="form-control" type="text" formControlName="lastname" readonly />
				</div>
			</div>

			<div class="row">
				<div class="col-md-4 form-group my-2">
					<label class="form-label">Date Reported</label>
					<input class="form-control" type="date" formControlName="datereported" readonly />
				</div>
				<div class="col-md-4 form-group my-2">
					<label class="form-label">Unit Number</label>
					<input class="form-control" type="number" formControlName="unit_number" readonly />
				</div>
				<div class="col-md-4 form-group my-2">
					<label class="form-label">Bylaw ID</label>
					<input class="form-control" type="number" formControlName="bylawid" readonly />
				</div>
			</div>

			<div class="row">
				<div class="col-md-6 form-group my-2">
					<label class="form-label">Reported By</label>
					<input class="form-control" type="text" formControlName="createdBy" readonly />
				</div>
				<div class="col-md-6 form-group my-2">
					<label class="form-label">Status</label>
					<input class="form-control" type="text" formControlName="status" readonly />
				</div>
			</div>

			<div class="form-group my-3">
				<label class="form-label">Property</label>
				<input class="form-control" type="text" formControlName="propertyName" readonly />
			</div>
		</form>
	</div>
}

@if (property?.id && action == 'list') {
	<div class="container">
		<div class="d-flex justify-content-between align-items-center">
			<h1 class="fs-2 fw-light mt-4">Manage Breaches</h1>
			<button (click)="onCreateBreach()" type="button" class="mt-4 btn btn-primary">
				Add <fa-icon [icon]="faCirclePlus"></fa-icon>
			</button>
		</div>

		<p class="text-muted">Property: {{ property.name }}</p>

		<div class="form-group has-search my-3">
			<fa-icon class="form-control-feedback" [icon]="faSearch"></fa-icon>
			<input type="text" name="searchBreach" [(ngModel)]="searchBreach" class="form-control" placeholder="Search breaches" />
		</div>

		@if (loading) {
			<div class="my-4">
				<span class="spinner-border spinner-border-sm mr-1"></span>
				<span>Loading breaches...</span>
			</div>
		}

		@if (!loading && breaches.length == 0) {
			<div class="alert alert-info">No breaches found for this property. Create your first breach.</div>
		}

		<ul class="list-group list-group-flush">
			@for (breach of breaches; track breach.id) {
				@if ((breach.title + ' ' + breach.description + ' ' + breach.status).toLowerCase().includes(searchBreach.toLowerCase())) {
					<li class="list-group-item">
						<button class="btn btn-link text-start p-0 text-decoration-none w-100" type="button" (click)="onSelectedBreach(breach)">
							<div class="d-flex justify-content-between align-items-center">
								<div>
									<strong class="text-primary">{{ breach.title }}</strong>
									<div class="text-muted small mt-1">{{ breach.description }}</div>
									<div class="text-secondary small mt-1">Unit {{ breach.unit_number }} | Status: {{ breach.status }}</div>
								</div>
								<fa-icon [icon]="faCircleArrowRight"></fa-icon>
							</div>
						</button>
					</li>
				}
			}
		</ul>
	</div>
}

@if (property?.id) {
	<div class="mt-4 d-flex container justify-content-between align-items-center">
		<button (click)="goBack()" type="button" class="btn btn-primary">
			<fa-icon [icon]="faCircleArrowLeft"></fa-icon> Back
		</button>

		@if (action == 'create') {
			<button [disabled]="fetching" class="btn btn-primary" (click)="createBreach()">
				Save
				@if (!fetching) {
					<fa-icon [icon]="faPaperPlane"></fa-icon>
				}
				@if (fetching) {
					<span class="spinner-border spinner-border-sm mr-1"></span>
				}
			</button>
		}

		@if (action == 'edit') {
			<div class="d-flex gap-2">
				<button [disabled]="fetching" class="btn btn-danger" (click)="onDeleteBreach()">
					Delete <fa-icon [icon]="faTrash"></fa-icon>
				</button>
				<button [disabled]="fetching" class="btn btn-info" (click)="updateBreach()">
					Update
					@if (!fetching) {
						<fa-icon [icon]="faPaperPlane"></fa-icon>
					}
					@if (fetching) {
						<span class="spinner-border spinner-border-sm mr-1"></span>
					}
				</button>
			</div>
		}

		@if (action == 'view') {
			<button [disabled]="fetching" class="btn btn-danger" (click)="onDeleteBreach()">
				Delete <fa-icon [icon]="faTrash"></fa-icon>
			</button>
		}
	</div>
}
